// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QgEY","colMin":"styles_colMin__2pQfq"};